<div class="background-gray default-block-padding-xl">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h2>{{ data.title }}</h2>
      </div>
      <div class="row">
        <div class="col-12">
          <div ngbAccordion>
            <div
              ngbAccordionItem
              *ngFor="let panel of data.panels; let i = index"
            >
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>{{ panel.title }}</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div
                      class="content"
                      [innerHTML]="panel.content | bypassSecurity"
                    ></div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
